import { createPlatformStyles, theme } from "../../../theme/theme";
import { isTablet } from "react-native-device-info";

export const { styles, ids } = createPlatformStyles({
  mobile: {
    container: {
      marginTop: isTablet() ? "12%" : -50,
    },
    buttonLogin: {
      borderRadius: theme.radius.xxs,
      paddingHorizontal: theme.spacing.xxl5,
      paddingVertical: theme.spacing.reg,
      backgroundColor: theme.colors.button.primary,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      minWidth: isTablet() ? 196 : "auto",
    },
    whiteText: {
      fontWeight: theme.fontweight.bold,
      textAlign: "center",
      color: theme.colors.text.white,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.md,
    },
    loginHere: {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      fontSize: theme.fontsize.xlg,
      marginTop: theme.spacing.xlg,
      fontFamily: theme.fontFamily.robotoRegular,
    },
    whiteTextSmall: {
      fontFamily: theme.fontFamily.robotoRegular,

      textAlign: "center",
      color: theme.colors.text.white,
      fontWeight: theme.fontweight.light,

      fontSize: theme.fontsize.cs,
    },
    loginLink: {
      fontSize: theme.fontsize.cs,
      color: theme.colors.text.white,
      fontWeight: theme.fontweight.regular,
      fontFamily: theme.fontFamily.robotoRegular,
      textDecorationLine: "underline",
    },
  },
  web: {
    container: {
      alignItems: "center",
    },
    buttonLogin: {
      paddingHorizontal: theme.spacing.xxl5,
      paddingVertical: theme.spacing.reg,
      backgroundColor: theme.colors.button.primary,

      textAlign: "center",
      display: "flex",
      alignItems: "center",
      borderRadius: theme.radius.xxs,
      cursor: "pointer",
      transition: "opacity 0.2s ease",
      width: 196,
      marginLeft: "auto",
      marginRight: "auto",
    },
    whiteText: {
      fontWeight: theme.fontweight.bold,
      textAlign: "center",
      color: theme.colors.text.white,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.md,
    },
    loginHere: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontSize: theme.fontsize.xlg,
      marginTop: theme.spacing.xlg,
      fontFamily: theme.fontFamily.robotoRegular,
    },
    whiteTextSmall: {
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.cs,
      textAlign: "center",
      color: theme.colors.text.white,
      fontWeight: theme.fontweight.light,
    },
    loginLink: {
      fontSize: theme.fontsize.cs,
      color: theme.colors.text.white,
      fontWeight: theme.fontweight.regular,
      fontFamily: theme.fontFamily.robotoRegular,
      textDecorationLine: "underline",
    },
    termsPolicy: {
      height: 60,
      zIndex: 9,
      bottom: 0,
      left: 0,
      right: 0,
      position: "fixed",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing.md,
    },
  },
});
